module.exports = __webpack_public_path__ + "img/no-sound.0d751509.svg";